import { useEffect } from 'react'

interface IRedirectRouterProps {
  url: string
}

const RedirectRouter = (props: IRedirectRouterProps) => {
  useEffect(() => {
    window.location.href = props.url
  }, [])

  return <></>
}

export { RedirectRouter }
